export const SCE_MODULES = {
    accessibility: 'accessibility',
    misspelling: 'spelling',
    readability: 'readability',
} as const;
